<template>
  <div
    v-if="receipt.fulfillmentType === 'Delivery'"
    class="cf-flex cf-flex--column cf-flex--gap-8"
  >
    <h3 class="cf-title cf-title--3">
      Delivery time:
    </h3>

    <p class="cf-subtitle cf-subtitle--2">
      {{ $momentCalendar(receipt.delivery.estimatedDeliveryTime, null, receipt.store.timeZone) }}
    </p>

    <p class="cf-subtitle cf-subtitle--2">
      Placed: {{ $momentCalendar(receipt.orderDate, null, receipt.store.timeZone) }}
    </p>
  </div>

  <div
    v-else-if="isPickupType"
    class="cf-flex cf-flex--column cf-flex--gap-8"
  >
    <h3 class="cf-title cf-title--3">
      Pickup time:
    </h3>

    <p class="cf-subtitle cf-subtitle--2">
      Pickup time {{ $momentCalendar(receipt.pickupDate, null, receipt.store.timeZone) }}
    </p>

    <p class="cf-subtitle cf-subtitle--2">
      Placed: {{ $momentCalendar(receipt.orderDate, null, receipt.store.timeZone) }}
    </p>
  </div>

  <div
    v-else-if="receipt.fulfillmentType === 'RoomService'"
    class="cf-flex cf-flex--column cf-flex--gap-8"
  >
    <h3 class="cf-title cf-title--3">
      Delivery time:
    </h3>

    <p class="cf-subtitle cf-subtitle--2">
      {{ $momentCalendar(receipt.pickupDate, null, receipt.store.timeZone) }}
    </p>

    <p class="cf-subtitle cf-subtitle--2">
      Placed: {{ $momentCalendar(receipt.orderDate, null, receipt.store.timeZone) }}
    </p>
  </div>
</template>


<script>
  export default {
    name: 'OrderHistoryReceiptFulfillmentTime',

    props: {
      receipt: {
        type: Object,
        required: true
      }
    },

    computed: {
      isPickupType() {
        return this.receipt.fulfillmentType === 'Takeout'
          || this.receipt.fulfillmentType === 'Curbside'
          || this.receipt.fulfillmentType === 'DriveThrough';
      }
    }
  };
</script>
